import React from 'react';
import dataStandarPerilaku from './dataStandarPerilaku.json';

const StandarTataPerilaku = () => {
  return (
    <section className="bg-white pt-10 px-4">
      <div className="container mx-auto">
        
        {/* Header Section */}
        <div className="mb-12 text-center" data-aos="fade-down">
          <h2 className="text-3xl font-bold text-[#005da2] mb-6">
            Standar Tata Perilaku
          </h2>
        </div>

        {/* Render Section dari JSON */}
        {dataStandarPerilaku.map((item, index) => (
          <div key={index} className="mb-12 pl-6 py-2" data-aos="fade-up">
            {/* Judul Kategori (h3) */}
            <h3 className="text-xl font-semibold text-gray-800 mb-2">
              {item.title}
            </h3>
            
            {/* Intro */}
            {Array.isArray(item.intro) ? (
            item.intro.map((text, iIdx) => (
              <p key={iIdx} className="text-lg text-gray-700 leading-relaxed text-justify mb-4">
                {text}
              </p>
            ))
          ) : (
            <p className={`text-lg text-gray-700 leading-relaxed text-justify ${item.points ? 'mb-4' : ''}`}>
              {item.intro}
            </p>
          )}
            
            {/* List muncul klo ada data points */}
            {item.points && (
              <ol className="list-decimal ml-6 space-y-3 text-lg text-gray-700 leading-relaxed mt-4">
                {item.points.map((point, pIdx) => (
                  <li key={pIdx} className="pl-2 text-justify">
                    {point}
                  </li>
                ))}
              </ol>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default StandarTataPerilaku;